module.exports = __webpack_public_path__ + "img/ntc1.c2bdb951.png";